import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViaSupportService } from '../../../services/support/via-support/via-support.service';
import { ViaName } from '@web/dtos';

@Component({
  selector: 'aw-via-banner',
  imports: [CommonModule],
  templateUrl: './via-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViaBannerComponent implements OnChanges {
  private viaService: ViaSupportService = inject(ViaSupportService);
  public readonly bannerOverflow: InputSignal<string> = input.required();
  public readonly via: InputSignal<ViaName[]> = input.required();
  public viaAriaLabel: string = '';

  ngOnChanges(): void {
    this.viaAriaLabel = this.viaService.buildViaString(this.via());
  }
}
